export default __webpack_public_path__ + "static/media/approved-with-warning-icon.033b363f.svg";